@for (title of titles(); track title; let i = $index) {
  <button
    class="no-style  sidebar-item-class-{{ title }}"
    role="menuitem"
    (click)="openMenu(title)">
    <h3>{{ 'side-menu.' + title | translate }}</h3>
  </button>
}
